module.exports = __webpack_public_path__ + "static/city-top-0d6bc5e8db65855922ef329b76a990a1.png";